import { schoolTokenAxios } from "../axios";

const ORG_BASE = process.env.REACT_APP_ORG_BASE;

let school_url = `${ORG_BASE}/schoolSelf`;
let payment_url = `${ORG_BASE}/payment`;

export const getAllSessionOrderBySchool = (params) => {
  return schoolTokenAxios.get(`${school_url}/getAllSessionOrderBySchool`, {
    params,
  });
};
export const getTransactionBySessionOrder = (params) => {
  return schoolTokenAxios.get(`${school_url}/getTransactionBySessionOrder`, {
    params,
  });
};
export const getInvoice = (params) => {
  return schoolTokenAxios.get(`${school_url}/getInvoice`, {
    params,
  });
};

export const purchaseSessionOrder = (payload) => {
  return schoolTokenAxios.post(`${payment_url}/purchaseSessionOrder`, payload);
};

export const saveSuccessPaymentDetail = (payload) => {
  return schoolTokenAxios.post(
    `${payment_url}/saveSuccessPaymentDetail`,
    payload
  );
};

export const saveFailedPaymentDetail = (payload) => {
  return schoolTokenAxios.post(
    `${payment_url}/saveFailedPaymentDetail`,
    payload
  );
};

export const sendOtpForAcceptingConsent = (payload) => {
  return schoolTokenAxios.post(
    `${school_url}/sendOtpForAcceptingConsent`,
    payload
  );
};

export const verifyOTP_forConsent = (payload) => {
  return schoolTokenAxios.post(`${school_url}/verifyOTP_forConsent`, payload);
};

export const createDueDateThread = (payload) => {
  return schoolTokenAxios.post(`${school_url}/createDueDateThread`, payload);
};

export const getDueDateThread = () => {
  return schoolTokenAxios.get(`${school_url}/getDueDateThread`);
};

export const getProduct = (params) => {
  return schoolTokenAxios.get(`${school_url}/getProduct`, {
    params,
  });
};

// New Purchase Api

export const purchaseSessionEntity = (payload) => {
  return schoolTokenAxios.post(`${payment_url}/purchaseSessionEntity`, payload);
};

export const savePaymentForSessionEntity = (payload) => {
  return schoolTokenAxios.post(
    `${payment_url}/savePaymentForSessionEntity`,
    payload
  );
};
